(function () {
  function initialise(root) {
    if (!root || root.dataset.claceReady === "true") return;

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-cl-plan-card]"));
    var recommenders = Array.prototype.slice.call(root.querySelectorAll("[data-cl-plan-choice]"));
    var recommendation = root.querySelector("[data-cl-recommendation]");
    var form = root.querySelector("form");
    if (!cards.length) return;

    function activate(card, updateUrl) {
      if (!card || card.dataset.available === "false") return;

      cards.forEach(function (candidate) {
        var selected = candidate === card;
        var input = candidate.querySelector("[data-cl-plan-input]");
        var action = candidate.querySelector("[data-cl-plan-action]");
        var actionLabel = action && action.querySelector("[data-cl-action-label]");
        candidate.classList.toggle("is-selected", selected);
        if (input) input.checked = selected;
        if (actionLabel) {
          actionLabel.textContent = selected ? action.dataset.selectedLabel : action.dataset.idleLabel;
        }
      });

      recommenders.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.planKey === card.dataset.planKey));
      });

      if (recommendation) recommendation.textContent = card.dataset.planName || "";

      var input = card.querySelector("[data-cl-plan-input]");
      if (updateUrl && input && input.value && root.dataset.variantMode === "true" && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", input.value);
        window.history.replaceState({}, "", url.toString());
      }
    }

    cards.forEach(function (card) {
      card.addEventListener("click", function (event) {
        if (event.target.closest("[data-cl-plan-action]")) return;
        activate(card, true);
      });

      var action = card.querySelector("[data-cl-plan-action]");
      if (action) {
        action.addEventListener("click", function () {
          if (!card.classList.contains("is-selected")) {
            activate(card, true);
            return;
          }
          if (card.dataset.available === "false") return;
          if (root.dataset.variantMode === "true" && form) {
            form.requestSubmit();
          } else if (card.dataset.planLink) {
            window.location.href = card.dataset.planLink;
          }
        });
      }
    });

    recommenders.forEach(function (button) {
      button.addEventListener("click", function () {
        var card = cards.find(function (candidate) {
          return candidate.dataset.planKey === button.dataset.planKey;
        });
        activate(card, true);
      });
    });

    var requestedVariant = new URL(window.location.href).searchParams.get("variant");
    var initial = requestedVariant && cards.find(function (card) {
      var input = card.querySelector("[data-cl-plan-input]");
      return input && input.value === requestedVariant && card.dataset.available !== "false";
    });
    if (!initial) initial = cards.find(function (card) {
      return card.classList.contains("is-selected") && card.dataset.available !== "false";
    });
    if (!initial) {
      initial = cards.find(function (card) {
        return card.dataset.defaultSelected === "true" && card.dataset.available !== "false";
      });
    }
    if (!initial) {
      initial = cards.find(function (card) {
        return card.dataset.available !== "false";
      });
    }

    activate(initial, false);
    root.dataset.claceReady = "true";
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll("[data-cl-plans]").forEach(initialise);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialiseAll(event.target);
  });
})();
